import { Component, OnInit, Renderer2  } from '@angular/core';

@Component({
  selector: '.app-auth-layout.container-xxl',
  templateUrl: './auth-layout.component.html',
  styleUrls: [
    '../../../assets/vendor/css/pages/page-auth.css',
    './auth-layout.component.css'
  ]
})
export class AuthLayoutComponent {

}